// extracted by mini-css-extract-plugin
export var label = "_gi-2";
export var slideContainer = "_gi-0";
export var slider = "_gi-1";